module.exports = __webpack_public_path__ + "img/28.97d48feb.png";